import React from 'react';
import {TouchableOpacity, StyleSheet, Text} from 'react-native';

interface BackToTopButtonProps {
  onPress: () => void;
  visible: boolean;
}

const BackToTopButton: React.FC<BackToTopButtonProps> = ({
  onPress,
  visible,
}) => {
  if (!visible) return null;

  return (
    <TouchableOpacity style={styles.button} onPress={onPress}>
      <Text style={styles.arrow}>↑</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    position: 'absolute',
    bottom: 20,
    right: 20,
    width: 35,
    height: 35,
    backgroundColor: 'white',
    borderColor: 'red',
    borderWidth: 3,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 25,
    paddingBottom: 10,

    zIndex: 100000,
    color: 'red',
  },
  arrow: {
    color: 'red',
    fontWeight: 'bold',
    fontSize: 22,
    zIndex: 100001,
    margin: 0,
    padding: 0,
  },
});

export default BackToTopButton;
